import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../App";
import { useTheme } from "../contexts/ThemeContext";
import {
  Search,
  X,
  AlertTriangle,
  Filter,
  RefreshCw,
  CheckCircle,
  XCircle,
  Undo,
  Eye,
  Settings,
  Tag,
  Users,
  Package,
  Building2,
  Calendar,
  Loader,
  Clock,
  Euro,
  ChevronDown,
  TrendingDown,
  ChevronLeft,
  ChevronRight,
  Gift,
  ShoppingCart,
  Check,
  Mail,
  Star
} from "lucide-react";

const API_URL = process.env.REACT_APP_API_URL;

// Componente del Panel Lateral (sin cambios)
const SidePanel = ({ 
  isOpen, 
  setIsOpen,
  estadoFiltro,
  setEstadoFiltro,
  proveedorFiltro,
  setProveedorFiltro,
  fechaDesdeFiltro,
  setFechaDesdeFiltro,
  fechaHastaFiltro,
  setFechaHastaFiltro,
  productoBusqueda,
  setProductoBusqueda,
  handleLimpiarFiltros,
  loading,
  proveedores,
  ofertas,
  totalOfertas
}) => {
  const { theme } = useTheme();
  const bgPrimaryLight = { backgroundColor: theme.primaryLight };
  const textPrimary = { color: theme.primary };

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed left-4 top-1/2 transform -translate-y-1/2 z-50 bg-white border border-gray-300 rounded-r-lg p-3 shadow-lg hover:bg-gray-50 transition-all duration-300"
        style={{
          left: isOpen ? '384px' : '4px'
        }}
      >
        {isOpen ? <ChevronLeft size={20} className="text-gray-600" /> : <ChevronRight size={20} className="text-gray-600" />}
      </button>

      <div 
        className="fixed left-0 top-16 bottom-0 bg-white border-r border-gray-200 shadow-lg transition-transform duration-300 z-40 overflow-hidden"
        style={{
          width: '380px',
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)'
        }}
      >
        <div className="h-full flex flex-col">
          
          <div className="p-4 border-b border-gray-200" style={bgPrimaryLight}>
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-lg font-semibold text-gray-800 flex items-center">
                <Settings size={20} className="mr-2" style={textPrimary} />
                Panel de Control
              </h2>
            </div>
            <p className="text-sm text-gray-600">
              Filtros avanzados para gestión de ofertas agrupadas
            </p>
          </div>

          <div className="flex-1 overflow-y-auto">

            <div>
              <div className="p-4">
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                      <Package size={12} className="mr-1 text-gray-500" />
                      Producto
                    </label>
                    <input
                      type="text"
                      className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 rounded-lg shadow-sm transition-colors bg-white"
                      placeholder="Nombre del producto..."
                      value={productoBusqueda}
                      onChange={(e) => setProductoBusqueda(e.target.value)}
                    />
                  </div>
                  
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                      <Building2 size={12} className="mr-1 text-gray-500" />
                      Proveedor
                    </label>
                    <div className="relative">
                      <select
                        className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 rounded-lg shadow-sm transition-colors appearance-none bg-white"
                        value={proveedorFiltro}
                        onChange={(e) => setProveedorFiltro(e.target.value)}
                      >
                        <option value="">Todos los proveedores</option>
                        {proveedores.map((proveedor) => (
                          <option key={proveedor.id} value={proveedor.id}>
                            {proveedor.nombre}
                          </option>
                        ))}
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                        <ChevronDown size={14} className="text-gray-500" />
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                      <CheckCircle size={12} className="mr-1 text-gray-500" />
                      Estado
                    </label>
                    <div className="relative">
                      <select
                        className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 rounded-lg shadow-sm transition-colors appearance-none bg-white"
                        value={estadoFiltro}
                        onChange={(e) => setEstadoFiltro(e.target.value)}
                      >
                        <option value="">Todos los estados</option>
                        <option value="pendiente">Pendiente</option>
                        <option value="aprobada_parcial">Aprobada Parcial</option>
                        <option value="aprobada_completa">Aprobada Completa</option>
                        <option value="rechazada">Rechazada</option>
                        <option value="rollback">Terminada</option>
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                        <ChevronDown size={14} className="text-gray-500" />
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg p-3 border border-gray-200 shadow-sm">
                    <h4 className="font-medium text-gray-700 mb-3 text-xs flex items-center">
                      <Calendar size={14} className="mr-1" />
                      Rango de Fechas
                    </h4>
                    
                    <div className="space-y-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Fecha desde</label>
                        <input
                          type="date"
                          className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 rounded-lg shadow-sm transition-colors bg-white"
                          value={fechaDesdeFiltro}
                          onChange={(e) => setFechaDesdeFiltro(e.target.value)}
                        />
                      </div>
                      
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Fecha hasta</label>
                        <input
                          type="date"
                          className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 rounded-lg shadow-sm transition-colors bg-white"
                          value={fechaHastaFiltro}
                          onChange={(e) => setFechaHastaFiltro(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-2">
                    <button
                      onClick={handleLimpiarFiltros}
                      className="flex items-center justify-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-colors shadow-sm font-medium text-sm"
                    >
                      <RefreshCw size={14} className="mr-2" />
                      Limpiar Filtros
                    </button>
                  </div>
                </div>
              </div>
            </div>
          

          </div>
        </div>
      </div>
    </>
  );
};

const GestionOfertasAdmin = () => {
  const { user } = useContext(AuthContext);
  const modalRef = useRef(null);

  // ─── TEMA DINÁMICO ───────────────────────────────────────────────────
  const { theme } = useTheme();
  const bgPrimary = { backgroundColor: theme.primary };
  const bgPrimaryLight = { backgroundColor: theme.primaryLight };
  const bgPrimaryDark = { backgroundColor: theme.primaryDark };
  const textPrimary = { color: theme.primary };
  const textPrimaryDark = { color: theme.primaryDark };
  const borderPrimary = { borderColor: theme.primary };
  // ─────────────────────────────────────────────────────────────────────

  // Estados para el panel lateral
  const [sidePanelOpen, setSidePanelOpen] = useState(true);

  // Estados para ofertas
  const [ofertas, setOfertas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Estados para filtros
  const [estadoFiltro, setEstadoFiltro] = useState("");
  const [proveedorFiltro, setProveedorFiltro] = useState("");
  const [fechaDesdeFiltro, setFechaDesdeFiltro] = useState("");
  const [fechaHastaFiltro, setFechaHastaFiltro] = useState("");
  const [productoBusqueda, setProductoBusqueda] = useState("");

  // Estados para modal de detalles
  const [ofertaSeleccionada, setOfertaSeleccionada] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [motivoRechazo, setMotivoRechazo] = useState("");

  // Estados para selección de productos en aprobación
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [mostrandoSeleccionProductos, setMostrandoSeleccionProductos] = useState(false);

  // Estados para acciones
  const [accionando, setAccionando] = useState(false);

  // Estados para proveedores
  const [proveedores, setProveedores] = useState([]);

  // Estados para ofertas filtradas
  const [ofertasFiltradas, setOfertasFiltradas] = useState([]);

  const token = localStorage.getItem('token');

  // Cargar proveedores
  useEffect(() => {
    const fetchProveedores = async () => {
      try {
        const response = await fetch(`${API_URL}/api/proveedores`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setProveedores(data.proveedores || []);
        }
      } catch (error) {
        console.error("Error al cargar proveedores:", error);
      }
    };

    fetchProveedores();
  }, [token]);

  // Cargar ofertas
  useEffect(() => {
    const fetchOfertas = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await fetch(`${API_URL}/api/ofertas/admin`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Error al obtener las ofertas");
        }

        const data = await response.json();
        setOfertas(data.ofertas);
        setOfertasFiltradas(data.ofertas);
      } catch (error) {
        console.error("Error:", error);
        setError("No se pudieron cargar las ofertas. " + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOfertas();
  }, [token]);

  // Filtrar ofertas
  useEffect(() => {
    let filtradas = ofertas;

    if (estadoFiltro) {
      filtradas = filtradas.filter(oferta => oferta.estado === estadoFiltro);
    }

    if (proveedorFiltro) {
      filtradas = filtradas.filter(oferta => oferta.proveedor_id === parseInt(proveedorFiltro));
    }

    if (productoBusqueda.trim()) {
      filtradas = filtradas.filter(oferta => 
        oferta.productos && oferta.productos.some(producto =>
          producto.producto_nombre.toLowerCase().includes(productoBusqueda.toLowerCase())
        )
      );
    }

    if (fechaDesdeFiltro) {
      filtradas = filtradas.filter(oferta => 
        new Date(oferta.fecha_creacion) >= new Date(fechaDesdeFiltro)
      );
    }

    if (fechaHastaFiltro) {
      filtradas = filtradas.filter(oferta => 
        new Date(oferta.fecha_creacion) <= new Date(fechaHastaFiltro)
      );
    }

    // Ordenar por ID descendente
    filtradas = filtradas.sort((a, b) => b.id - a.id);

    setOfertasFiltradas(filtradas);
  }, [estadoFiltro, proveedorFiltro, productoBusqueda, fechaDesdeFiltro, fechaHastaFiltro, ofertas]);

  // Cerrar modal al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setModalVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Manejar selección de productos para aprobación
  const handleToggleProductoSeleccion = (productoId) => {
    setProductosSeleccionados(prev => {
      if (prev.includes(productoId)) {
        return prev.filter(id => id !== productoId);
      } else {
        return [...prev, productoId];
      }
    });
  };

  const handleSeleccionarTodosProductos = () => {
    if (!ofertaSeleccionada) return;
    
    const productosPendientes = ofertaSeleccionada.productos
      .filter(p => p.estado_producto === 'pendiente')
      .map(p => p.id);

    if (productosSeleccionados.length === productosPendientes.length) {
      setProductosSeleccionados([]);
    } else {
      setProductosSeleccionados(productosPendientes);
    }
  };

  // Aprobar oferta (completa o productos seleccionados)
  const handleAprobarOferta = async (ofertaId, productosIds = null) => {
    const mensajeConfirmacion = productosIds 
      ? `¿Está seguro de que desea aprobar ${productosIds.length} producto(s) seleccionado(s)? Los precios se actualizarán para TODOS los clientes que tienen estos productos.`
      : `¿Está seguro de que desea aprobar TODA la oferta? Los precios se actualizarán para TODOS los clientes de TODOS los productos.`;

    if (!window.confirm(mensajeConfirmacion)) {
      return;
    }

    try {
      setAccionando(true);

      const requestBody = productosIds ? { productos_ids: productosIds } : {};

      const response = await fetch(`${API_URL}/api/ofertas/${ofertaId}/aprobar`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al aprobar la oferta");
      }

      const result = await response.json();
      alert(result.message);
      
      // Recargar ofertas
      const responseOfertas = await fetch(`${API_URL}/api/ofertas/admin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (responseOfertas.ok) {
        const dataOfertas = await responseOfertas.json();
        setOfertas(dataOfertas.ofertas);
        setOfertasFiltradas(dataOfertas.ofertas);
      }

      setModalVisible(false);
      setProductosSeleccionados([]);
      setMostrandoSeleccionProductos(false);

    } catch (error) {
      console.error("Error:", error);
      alert("Error al aprobar la oferta: " + error.message);
    } finally {
      setAccionando(false);
    }
  };

  // Terminar oferta temporal (rollback)
  const handleTerminarOferta = async (ofertaId) => {
    if (!window.confirm("¿Está seguro de que desea terminar esta oferta temporal? Los precios volverán a su valor original y se notificará a todos los clientes.")) {
      return;
    }

    try {
      setAccionando(true);

      const response = await fetch(`${API_URL}/api/ofertas/${ofertaId}/terminar`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al terminar la oferta");
      }

      const result = await response.json();
      alert(result.message);
      
      // Recargar ofertas
      const responseOfertas = await fetch(`${API_URL}/api/ofertas/admin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (responseOfertas.ok) {
        const dataOfertas = await responseOfertas.json();
        setOfertas(dataOfertas.ofertas);
        setOfertasFiltradas(dataOfertas.ofertas);
      }

      setModalVisible(false);

    } catch (error) {
      console.error("Error:", error);
      alert("Error al terminar la oferta: " + error.message);
    } finally {
      setAccionando(false);
    }
  };
  const handleRechazarOferta = async (ofertaId) => {
    if (!motivoRechazo.trim()) {
      alert("Debe especificar un motivo de rechazo");
      return;
    }

    if (!window.confirm("¿Está seguro de que desea rechazar TODA la oferta?")) {
      return;
    }

    try {
      setAccionando(true);

      const response = await fetch(`${API_URL}/api/ofertas/${ofertaId}/rechazar`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          motivo: motivoRechazo
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al rechazar la oferta");
      }

      alert("Oferta rechazada correctamente.");
      
      // Recargar ofertas
      const responseOfertas = await fetch(`${API_URL}/api/ofertas/admin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (responseOfertas.ok) {
        const dataOfertas = await responseOfertas.json();
        setOfertas(dataOfertas.ofertas);
        setOfertasFiltradas(dataOfertas.ofertas);
      }

      setModalVisible(false);
      setMotivoRechazo("");

    } catch (error) {
      console.error("Error:", error);
      alert("Error al rechazar la oferta: " + error.message);
    } finally {
      setAccionando(false);
    }
  };

  // Ver detalles de oferta
  const handleVerDetalles = (oferta) => {
    setOfertaSeleccionada(oferta);
    setModalVisible(true);
    setMotivoRechazo("");
    setProductosSeleccionados([]);
    setMostrandoSeleccionProductos(false);
  };

  // Limpiar filtros
  const handleLimpiarFiltros = () => {
    setEstadoFiltro("");
    setProveedorFiltro("");
    setFechaDesdeFiltro("");
    setFechaHastaFiltro("");
    setProductoBusqueda("");
  };

  // Función para calcular precio con descuento
  const calcularPrecioConDescuento = (precioAnterior, porcentajeDescuento) => {
    const descuento = precioAnterior * (porcentajeDescuento / 100);
    return precioAnterior - descuento;
  };

  // Función para calcular estadísticas de precio por producto
  const calcularEstadisticasProducto = (clientesDatos) => {
    try {
      const clientes = JSON.parse(clientesDatos);
      const precios = Object.values(clientes);
      
      if (precios.length === 0) return null;
      
      const preciosAnteriores = precios.map(c => c.precio_anterior);
      const preciosNuevos = precios.map(c => c.precio_nuevo);
      
      const promedioAnterior = preciosAnteriores.reduce((sum, p) => sum + p, 0) / preciosAnteriores.length;
      const promedioNuevo = preciosNuevos.reduce((sum, p) => sum + p, 0) / preciosNuevos.length;
      
      return {
        promedioAnterior: Math.round(promedioAnterior * 100) / 100,
        promedioNuevo: Math.round(promedioNuevo * 100) / 100,
        totalClientes: precios.length
      };
    } catch (error) {
      console.error('Error calculando estadísticas:', error);
      return null;
    }
  };

  // Obtener clase CSS para el estado
  const getEstadoClass = (estado) => {
    switch (estado) {
      case 'pendiente':
        return "bg-yellow-100 text-yellow-800";
      case 'aprobada_parcial':
        return "bg-blue-100 text-blue-800";
      case 'aprobada_completa':
        return "bg-green-100 text-green-800";
      case 'rechazada':
        return "bg-red-100 text-red-800";
      case 'rollback':
        return "bg-orange-100 text-orange-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  // Obtener texto del estado
  const getEstadoTexto = (estado) => {
    switch (estado) {
      case 'pendiente':
        return 'Pendiente';
      case 'aprobada_parcial':
        return 'Aprobada Parcial';
      case 'aprobada_completa':
        return 'Aprobada Completa';
      case 'rechazada':
        return 'Rechazada';
      case 'rollback':
        return 'Terminada';
      default:
        return estado.charAt(0).toUpperCase() + estado.slice(1);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES");
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  // Verificar si el usuario es admin
  if (user?.permisos !== 1) {
    return (
      <div className="fixed inset-x-0 top-16 bottom-0 bg-gray-50 flex justify-center items-center">
        <div className="bg-red-100 text-red-800 p-6 rounded-xl shadow-lg max-w-lg w-full border border-red-200 mx-4">
          <div className="flex items-start">
            <AlertTriangle size={28} className="text-red-500 mr-4 flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-bold text-lg text-red-700 mb-2">Acceso Denegado</h3>
              <p className="text-red-700">No tienes permisos para acceder a esta sección.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (loading && ofertas.length === 0) {
    return (
      <div className="fixed inset-x-0 top-16 bottom-0 bg-gray-50 flex justify-center items-center">
        <div className="text-center">
          <div className="relative mb-8">
            <div className="w-20 h-20 border-4 rounded-full animate-spin mx-auto" style={{ borderColor: theme.primaryLight, borderTopColor: theme.primary }}></div>
            <Settings className="w-8 h-8 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" style={textPrimary} />
          </div>
          <h3 className="text-xl font-bold mb-2" style={textPrimary}>Cargando ofertas</h3>
          <p className="text-gray-600">Obteniendo lista de ofertas...</p>
        </div>
      </div>
    );
  }

  if (error && ofertas.length === 0) {
    return (
      <div className="fixed inset-x-0 top-16 bottom-0 bg-gray-50 flex justify-center items-center">
        <div className="bg-red-100 text-red-800 p-6 rounded-xl shadow-lg max-w-lg w-full border border-red-200 mx-4">
          <div className="flex items-start">
            <AlertTriangle size={28} className="text-red-500 mr-4 flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-bold text-lg text-red-700 mb-2">Error de carga</h3>
              <p className="text-red-700">{error}</p>
              <button 
                onClick={() => window.location.reload()}
                className="mt-4 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-md transition-all duration-200 inline-flex items-center"
              >
                <RefreshCw size={16} className="mr-2" />
                Reintentar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-x-0 top-16 bottom-0 bg-gray-50 overflow-hidden">

      {/* Panel Lateral */}
      <SidePanel
        isOpen={sidePanelOpen}
        setIsOpen={setSidePanelOpen}
        estadoFiltro={estadoFiltro}
        setEstadoFiltro={setEstadoFiltro}
        proveedorFiltro={proveedorFiltro}
        setProveedorFiltro={setProveedorFiltro}
        fechaDesdeFiltro={fechaDesdeFiltro}
        setFechaDesdeFiltro={setFechaDesdeFiltro}
        fechaHastaFiltro={fechaHastaFiltro}
        setFechaHastaFiltro={setFechaHastaFiltro}
        productoBusqueda={productoBusqueda}
        setProductoBusqueda={setProductoBusqueda}
        handleLimpiarFiltros={handleLimpiarFiltros}
        loading={loading}
        proveedores={proveedores}
        ofertas={ofertas}
        totalOfertas={ofertas.length}
      />

      {/* Área Principal */}
      <div className="h-full flex flex-col" style={{ 
        marginLeft: sidePanelOpen ? '380px' : '0px',
        transition: 'margin-left 0.3s ease-in-out'
      }}>
        
        {/* Header */}
        <div className="flex-shrink-0 bg-white shadow-sm border-b border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="p-2 rounded-lg mr-3" style={bgPrimaryLight}>
                <Gift size={20} style={textPrimary} />
              </div>
              <div>
                <h1 className="text-lg font-bold text-gray-800">Gestión de Ofertas</h1>
                <p className="text-sm text-gray-600">Revisar, aprobar y gestionar ofertas de proveedores</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <div className="text-right">
                <div className="text-sm font-medium text-gray-900">
                  {ofertasFiltradas.length} ofertas encontradas
                </div>
                <div className="text-xs text-gray-500">
                  Pendientes: {ofertasFiltradas.filter(o => o.estado === 'pendiente').length} | 
                  Parciales: {ofertasFiltradas.filter(o => o.estado === 'aprobada_parcial').length} | 
                  Terminadas: {ofertasFiltradas.filter(o => o.estado === 'rollback').length}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contenido Principal */}
        <div className="flex-1 overflow-auto">
          <div className="container mx-auto p-6 max-w-7xl">

            {ofertasFiltradas.length > 0 ? (
              <div className="space-y-6">
                {ofertasFiltradas.map((oferta) => (
                  <div key={oferta.id} className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
                    
                    {/* Header de la oferta */}
                    <div className="p-4" style={bgPrimary}>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div>
                            <h3 className="text-lg font-bold text-white">Oferta #{oferta.id}</h3>
                            <p className="text-sm text-white text-opacity-90">
                              {oferta.proveedor_nombre} • {oferta.total_productos} productos • {oferta.total_clientes} clientes
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-3">
                          <span className={`px-3 py-1 rounded-full text-sm font-medium ${getEstadoClass(oferta.estado)}`}>
                            {getEstadoTexto(oferta.estado)}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Contenido de la oferta */}
                    <div className="p-6">
                      

                      {/* Productos preview - CAMBIADO para mostrar precios en lugar de número de clientes */}
                      <div className="bg-gray-50 rounded-lg p-4 mb-4">
                        <h4 className="font-semibold text-gray-800 mb-3">Productos en la Oferta</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                          {oferta.productos && oferta.productos.slice(0, 6).map(producto => {
                            const estadisticas = calcularEstadisticasProducto(producto.clientes_datos);

                            return (
                              <div key={producto.id} className="bg-white rounded-lg p-3 border border-gray-200">
                                <div className="flex items-center justify-between mb-2">
                                  <div className="flex-1">
                                    <div className="font-medium text-gray-900 text-sm">{producto.producto_nombre}</div>
                                    <div className="text-xs text-gray-600">{producto.ref_proveedor || 'Sin ref.'}</div>
                                    <div className="text-xs text-gray-500">{estadisticas?.totalClientes || 0} clientes</div>
                                  </div>
                                  <span className={`px-2 py-1 rounded text-xs font-medium ${getEstadoClass(producto.estado_producto)}`}>
                                    {getEstadoTexto(producto.estado_producto)}
                                  </span>
                                </div>
                                
                                {/* Mostrar precios en lugar de número de clientes */}
                                {estadisticas && (
                                  <div className="mt-2 pt-2 border-t border-gray-200">
                                    <div className="text-xs">
                                      <div className="flex justify-between items-center mb-1">
                                        <span className="text-gray-600">Precio anterior:</span>
                                        <span className="font-medium text-gray-800">{formatCurrency(estadisticas.promedioAnterior)}</span>
                                      </div>
                                      <div className="flex justify-between items-center mb-1">
                                        <span className="text-gray-600">Precio nuevo:</span>
                                        <span className="font-medium text-green-600">{formatCurrency(estadisticas.promedioNuevo)}</span>
                                      </div>
                                      <div className="flex justify-between items-center">
                                        <span className="text-gray-600">Descuento:</span>
                                        <span className="font-bold text-red-600">-{producto.porcentaje_descuento || 0}%</span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                          {oferta.productos && oferta.productos.length > 6 && (
                            <div className="bg-gray-100 rounded-lg p-3 border border-gray-200 flex items-center justify-center">
                              <span className="text-gray-600 text-sm">+{oferta.productos.length - 6} más...</span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Acciones */}
                      <div className="flex flex-wrap gap-2 justify-end">
                        <button
                          onClick={() => handleVerDetalles(oferta)}
                          className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 px-4 py-2 text-sm rounded-lg inline-flex items-center transition-colors"
                        >
                          <Eye size={16} className="mr-2" />
                          Ver Detalles
                        </button>

                        {(oferta.estado === 'pendiente' || oferta.estado === 'aprobada_parcial') && (
                          <button
                            onClick={() => {
                              setOfertaSeleccionada(oferta);
                              setMostrandoSeleccionProductos(true);
                              setModalVisible(true);
                            }}
                            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 text-sm rounded-lg inline-flex items-center transition-colors"
                          >
                            <CheckCircle size={16} className="mr-2" />
                            Aprobar Productos
                          </button>
                        )}

                        {oferta.estado === 'pendiente' && (
                          <button
                            onClick={() => {
                              setOfertaSeleccionada(oferta);
                              setMostrandoSeleccionProductos(false);
                              setModalVisible(true);
                            }}
                            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 text-sm rounded-lg inline-flex items-center transition-colors"
                          >
                            <XCircle size={16} className="mr-2" />
                            Rechazar Oferta
                          </button>
                        )}

                        {/* Botón para terminar oferta temporal */}
                        {(oferta.estado === 'aprobada_parcial' || oferta.estado === 'aprobada_completa') &&
                         oferta.fecha_inicio && oferta.fecha_fin && (
                          <button
                            onClick={() => handleTerminarOferta(oferta.id)}
                            disabled={accionando}
                            className={`px-4 py-2 text-sm rounded-lg inline-flex items-center transition-colors ${
                              accionando
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                : 'bg-amber-600 hover:bg-amber-700 text-white'
                            }`}
                          >
                            <Clock size={16} className="mr-2" />
                            Terminar Oferta
                          </button>
                        )}
                      </div>

                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-white p-10 rounded-xl text-center border border-gray-200 shadow-sm">
                <div className="flex flex-col items-center justify-center">
                  <div className="p-4 rounded-full mb-4" style={bgPrimaryLight}>
                    <Gift size={40} style={textPrimary} />
                  </div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">No hay ofertas para mostrar</h3>
                  <p className="text-gray-600 max-w-lg mx-auto mb-6">
                    No se encontraron ofertas con los filtros aplicados.
                  </p>
                  <button
                    onClick={handleLimpiarFiltros}
                    className="text-white py-2 px-6 rounded-lg transition-colors inline-flex items-center shadow-sm"
                    style={bgPrimary}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = theme.primaryDark}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = theme.primary}
                  >
                    <RefreshCw size={16} className="mr-2" />
                    Limpiar filtros
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal de Detalles/Acciones */}
      {modalVisible && ofertaSeleccionada && (
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div
            className="bg-white rounded-xl shadow-2xl w-full max-w-7xl max-h-[90vh] overflow-hidden"
            ref={modalRef}
          >
            <div className="p-5" style={bgPrimary}>
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-bold text-white">
                  {mostrandoSeleccionProductos ? 'Seleccionar Productos para Aprobar' : 'Detalles de Oferta'} #{ofertaSeleccionada.id}
                </h3>
                <button
                  onClick={() => setModalVisible(false)}
                  className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
              
              {mostrandoSeleccionProductos ? (
                // Vista de selección de productos
                <div>
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                    <h4 className="font-semibold text-blue-800 mb-2">Selecciona los productos que deseas aprobar</h4>
                    <p className="text-blue-700 text-sm">
                      Los productos seleccionados serán aprobados y sus precios se actualizarán automáticamente. 
                      Los clientes recibirán notificaciones por email sobre los nuevos precios.
                    </p>
                  </div>

                  {/* Botones de selección */}
                  <div className="flex justify-between items-center mb-4">
                    <h4 className="font-semibold text-gray-800">
                      Productos Pendientes ({ofertaSeleccionada.productos?.filter(p => p.estado_producto === 'pendiente').length || 0})
                    </h4>
                    <button
                      onClick={handleSeleccionarTodosProductos}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded text-sm transition-colors"
                    >
                      {productosSeleccionados.length === ofertaSeleccionada.productos?.filter(p => p.estado_producto === 'pendiente').length 
                        ? 'Deseleccionar Todos' : 'Seleccionar Todos'}
                    </button>
                  </div>

                  {/* Lista de productos para selección */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    {ofertaSeleccionada.productos?.filter(p => p.estado_producto === 'pendiente').map(producto => {
                      const estadisticas = calcularEstadisticasProducto(producto.clientes_datos);
                      const isSelected = productosSeleccionados.includes(producto.id);

                      return (
                        <div 
                          key={producto.id} 
                          className={`p-4 rounded-lg border-2 transition-all cursor-pointer ${
                            isSelected 
                              ? 'border-green-500 bg-green-50' 
                              : 'border-gray-200 bg-white hover:border-gray-300'
                          }`}
                          onClick={() => handleToggleProductoSeleccion(producto.id)}
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex items-center flex-1">
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => handleToggleProductoSeleccion(producto.id)}
                                className="h-4 w-4 text-green-600 mr-3"
                                onClick={(e) => e.stopPropagation()}
                              />
                              <div className="flex-1">
                                <h5 className="font-medium text-gray-900">{producto.producto_nombre}</h5>
                                <p className="text-sm text-gray-600">{producto.ref_proveedor || 'Sin ref.'} {producto.marca && `• ${producto.marca}`}</p>
                                <p className="text-xs text-gray-500 mt-1">{estadisticas?.totalClientes || 0} clientes afectados</p>
                                {estadisticas && (
                                  <div className="text-xs text-gray-600 mt-2">
                                    <div>Precio anterior: {formatCurrency(estadisticas.promedioAnterior)}</div>
                                    <div>Precio nuevo: {formatCurrency(estadisticas.promedioNuevo)}</div>
                                    <div>Descuento: <span className="font-bold text-red-600">-{producto.porcentaje_descuento}%</span></div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Botones de acción para selección */}
                  <div className="flex justify-end space-x-4">
                    <button
                      onClick={() => setMostrandoSeleccionProductos(false)}
                      className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      Cancelar
                    </button>
                    <button
                      onClick={() => handleAprobarOferta(ofertaSeleccionada.id, productosSeleccionados)}
                      disabled={productosSeleccionados.length === 0 || accionando}
                      className={`px-6 py-2 rounded-lg transition-colors inline-flex items-center ${
                        productosSeleccionados.length === 0 || accionando
                          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                          : 'bg-green-600 hover:bg-green-700 text-white'
                      }`}
                    >
                      {accionando ? (
                        <>
                          <Loader size={16} className="mr-2 animate-spin" />
                          Procesando...
                        </>
                      ) : (
                        <>
                          <CheckCircle size={16} className="mr-2" />
                          Aprobar {productosSeleccionados.length} Producto{productosSeleccionados.length !== 1 ? 's' : ''}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              ) : (
                // Vista de detalles completos
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  
                  {/* Columna 1 - Información General */}
                  <div className="space-y-6">
                    
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                        <Building2 size={16} className="mr-2" style={textPrimary} />
                        Proveedor
                      </h4>
                      <div className="space-y-2 text-sm">
                        <div><span className="font-medium">Nombre:</span> {ofertaSeleccionada.proveedor_nombre}</div>
                        <div><span className="font-medium">Email:</span> {ofertaSeleccionada.proveedor_email || 'No especificado'}</div>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                        <Calendar size={16} className="mr-2" style={textPrimary} />
                        Fechas
                      </h4>
                      <div className="space-y-2 text-sm">
                        <div><span className="font-medium">Creada:</span> {formatDate(ofertaSeleccionada.fecha_creacion)}</div>
                        {ofertaSeleccionada.fecha_aprobacion && (
                          <div><span className="font-medium">Procesada:</span> {formatDate(ofertaSeleccionada.fecha_aprobacion)}</div>
                        )}
                        {ofertaSeleccionada.aprobada_por_usuario && (
                          <div><span className="font-medium">Por:</span> {ofertaSeleccionada.aprobada_por_usuario}</div>
                        )}
                      </div>
                    </div>

                    {ofertaSeleccionada.comentarios && (
                      <div className="bg-gray-50 rounded-lg p-4">
                        <h4 className="font-semibold text-gray-800 mb-3">Comentarios</h4>
                        <p className="text-sm text-gray-700 whitespace-pre-wrap">{ofertaSeleccionada.comentarios}</p>
                      </div>
                    )}
                  </div>

                  {/* Columna 2 - Configuración y Estado */}
                  <div className="space-y-6">
                    
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                        <TrendingDown size={16} className="mr-2" style={textPrimary} />
                        Configuración de Oferta
                      </h4>
                      <div className="space-y-2 text-sm">
                        <div><span className="font-medium">Descuento:</span> <span className="font-bold text-red-600">-{ofertaSeleccionada.porcentaje_descuento}%</span></div>
                        <div><span className="font-medium">Tipo:</span> {ofertaSeleccionada.fecha_inicio && ofertaSeleccionada.fecha_fin ? 'Temporal' : 'Atemporal'}</div>
                        {ofertaSeleccionada.fecha_inicio && ofertaSeleccionada.fecha_fin && (
                          <div><span className="font-medium">Período:</span> {formatDate(ofertaSeleccionada.fecha_inicio)} - {formatDate(ofertaSeleccionada.fecha_fin)}</div>
                        )}
                        <div><span className="font-medium">Estado:</span> 
                          <span className={`ml-2 px-2 py-1 rounded text-xs font-medium ${getEstadoClass(ofertaSeleccionada.estado)}`}>
                            {getEstadoTexto(ofertaSeleccionada.estado)}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                      <h4 className="font-semibold text-gray-800 mb-3">Estadísticas</h4>
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center">
                          <div className="text-xl font-bold text-blue-600">{ofertaSeleccionada.total_productos}</div>
                          <div className="text-xs text-blue-700">Total Productos</div>
                        </div>
                        <div className="text-center">
                          <div className="text-xl font-bold text-green-600">{ofertaSeleccionada.productos_aprobados}</div>
                          <div className="text-xs text-green-700">Aprobados</div>
                        </div>
                        <div className="text-center">
                          <div className="text-xl font-bold text-purple-600">{ofertaSeleccionada.total_clientes}</div>
                          <div className="text-xs text-purple-700">Clientes</div>
                        </div>
                        <div className="text-center">
                          <div className="text-xl font-bold text-red-600">-{ofertaSeleccionada.porcentaje_descuento}%</div>
                          <div className="text-xs text-red-700">Descuento</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Columna 3 - Lista de Productos */}
                  <div className="space-y-6">
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                        <Package size={16} className="mr-2" style={textPrimary} />
                        Productos ({ofertaSeleccionada.total_productos})
                      </h4>
                      
                      <div className="max-h-96 overflow-y-auto">
                        <div className="space-y-3">
                          {ofertaSeleccionada.productos && ofertaSeleccionada.productos.map(producto => {
                            const estadisticas = calcularEstadisticasProducto(producto.clientes_datos);

                            return (
                              <div key={producto.id} className="bg-white rounded-lg p-3 border border-gray-200 shadow-sm">
                                <div className="flex items-center justify-between mb-2">
                                  <div className="flex-1">
                                    <div className="font-medium text-gray-900 text-sm">{producto.producto_nombre}</div>
                                    <div className="text-xs text-gray-600">{producto.ref_proveedor || 'Sin ref.'} {producto.marca && `• ${producto.marca}`}</div>
                                  </div>
                                  <span className={`px-2 py-1 rounded text-xs font-medium ${getEstadoClass(producto.estado_producto)}`}>
                                    {getEstadoTexto(producto.estado_producto)}
                                  </span>
                                </div>
                                <div className="text-xs text-gray-500">
                                  {estadisticas?.totalClientes || 0} clientes afectados
                                </div>
                                {estadisticas && (
                                  <div className="text-xs text-gray-600 mt-1">
                                    <div>Descuento: <span className="font-bold text-red-600">-{producto.porcentaje_descuento}%</span></div>
                                    <div>Anterior: {formatCurrency(estadisticas.promedioAnterior)} → Nuevo: {formatCurrency(estadisticas.promedioNuevo)}</div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Botones de acción para vista de detalles */}
              {!mostrandoSeleccionProductos && (
                <div className="border-t border-gray-200 pt-6 mt-8">
                  <div className="flex flex-wrap gap-2 justify-end items-start">

                    {(ofertaSeleccionada.estado === 'pendiente' || ofertaSeleccionada.estado === 'aprobada_parcial') && (
                      <>
                        <button
                          onClick={() => setMostrandoSeleccionProductos(true)}
                          className={`px-4 py-2 rounded-lg transition-colors inline-flex items-center text-sm font-medium ${
                            accionando
                              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                              : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                          }`}
                          disabled={accionando}
                        >
                          <CheckCircle size={16} className="mr-2" />
                          Seleccionar Productos
                        </button>

                        <button
                          onClick={() => handleAprobarOferta(ofertaSeleccionada.id)}
                          disabled={accionando}
                          className={`px-4 py-2 rounded-lg transition-colors inline-flex items-center text-sm font-medium ${
                            accionando
                              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                              : 'bg-green-600 hover:bg-green-700 text-white'
                          }`}
                        >
                          {accionando ? (
                            <>
                              <Loader size={16} className="mr-2 animate-spin" />
                              Procesando...
                            </>
                          ) : (
                            <>
                              <Star size={16} className="mr-2" />
                              Aprobar TODA la Oferta
                            </>
                          )}
                        </button>
                      </>
                    )}

                    {/* Botón para terminar oferta temporal en modal */}
                    {(ofertaSeleccionada.estado === 'aprobada_parcial' || ofertaSeleccionada.estado === 'aprobada_completa') &&
                     ofertaSeleccionada.fecha_inicio && ofertaSeleccionada.fecha_fin && (
                      <button
                        onClick={() => handleTerminarOferta(ofertaSeleccionada.id)}
                        disabled={accionando}
                        className={`px-4 py-2 rounded-lg transition-colors inline-flex items-center text-sm font-medium ${
                          accionando
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            : 'bg-amber-600 hover:bg-amber-700 text-white'
                        }`}
                      >
                        {accionando ? (
                          <>
                            <Loader size={16} className="mr-2 animate-spin" />
                            Terminando...
                          </>
                        ) : (
                          <>
                            <Clock size={16} className="mr-2" />
                            Terminar Oferta Temporal
                          </>
                        )}
                      </button>
                    )}

                    {ofertaSeleccionada.estado === 'pendiente' && (
                      <div className="flex space-x-2 flex-1 max-w-md">
                        <input
                          type="text"
                          placeholder="Motivo de rechazo..."
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-red-400 focus:border-red-400 text-sm"
                          value={motivoRechazo}
                          onChange={(e) => setMotivoRechazo(e.target.value)}
                        />
                        <button
                          onClick={() => handleRechazarOferta(ofertaSeleccionada.id)}
                          disabled={accionando || !motivoRechazo.trim()}
                          className={`px-4 py-2 rounded-lg transition-colors inline-flex items-center text-sm font-medium ${
                            accionando || !motivoRechazo.trim()
                              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                              : 'bg-red-600 hover:bg-red-700 text-white'
                          }`}
                        >
                          <XCircle size={16} className="mr-2" />
                          Rechazar
                        </button>
                      </div>
                    )}

                    <button
                      onClick={() => setModalVisible(false)}
                      className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default GestionOfertasAdmin;